/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmbedJobId } from '../models/EmbedJobId';
import type { EmbedSentences } from '../models/EmbedSentences';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EmbeddingService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Embed Sentences
     * @param requestBody
     * @returns EmbedJobId Successful Response
     * @throws ApiError
     */
    public embedSentencesEmbeddingPost(
        requestBody: EmbedSentences,
    ): CancelablePromise<EmbedJobId> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/embedding/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
